import { Helmet } from 'react-helmet-async';
import { Navigate, useParams } from 'react-router';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import StationeryReturnDetailView from 'src/sections/stationery-return/view/stationery-return-detail-view';

export default function StationeryReturnDetailPage() {
  const { user: authUser } = useAuthContext();

  const params = useParams();

  const { id } = params;

  return (
    <>
      <Helmet>
        <title> Stationery return details</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_STATIONERY_RETURN,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <StationeryReturnDetailView id={`${id}`} />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
